import { ActivityApiAsyncImportModel } from "./ActivityApiAsyncImport.model";

export class ActivityApiAsyncImport extends ActivityApiAsyncImportModel {
    // Add custom methods here
}
